import type { Response, CollectionResponse } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface RoleFormParams {
  name: string
  description: string
  status: number
}

export interface AssignPermissionParams {
  role_id: string | number
  permissions: string[]
}

export const roleService = {
  list() {
    return HttpRequest.get("v1/role/list").json<CollectionResponse>()
  },

  create(params: RoleFormParams) {
    return HttpRequest.post("v1/role/create", {
      json: params,
    }).json<Response>()
  },

  getById(id: string | number) {
    return HttpRequest.get(`v1/role/detail/${id}`).json<Response>()
  },

  update(id: string | number, params: RoleFormParams) {
    return HttpRequest.put(`v1/role/update/${id}`, {
      json: params,
    }).json<Response>()
  },

  assignPermission(params: AssignPermissionParams) {
    return HttpRequest.post("v1/role/permission/assign", {
      json: params,
    }).json<Response>()
  },

  getPermissions(roleId: string | number) {
    return HttpRequest.get(`v1/role/permission/list/${roleId}`).json<Response>()
  },

  getAccounts(roleId: string | number) {
    return HttpRequest.get(`v1/role/account/list/${roleId}`).json<Response>()
  },
}
